import { Button } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import { Seo } from 'components'
import { useRootLink } from 'hooks/useRootLink'

import { TechPageTemplate } from '../template'

export const NotFoundPage = () => {
  const navigate = useNavigate()
  const rootLink = useRootLink()

  const handleClick = () => {
    if (!rootLink) {
      return
    }
    navigate(rootLink)
  }

  return (
    <>
      <Seo
        description="Страница, которую вы ищете, перемещена или никогда не существовала. Попробуйте выполнить поиск заново."
        title="Страница не найдена!"
      />
      <TechPageTemplate
        text="Возможно, страница не существует или удалена. Проверьте правильность введённого адреса."
        title="Страница не найдена"
        actions={
          <Button disabled={!rootLink} onClick={handleClick} size="lg" variant="outline">
            Перейти на главную
          </Button>
        }
        icon={
          <div
            className="mb-5 flex h-[116px] w-[116px] items-center justify-center rounded-full bg-brand text-[48px] text-on-primary md:mb-10"
            data-test-id="not--found--page"
          >
            404
          </div>
        }
      />
    </>
  )
}
